var _line;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLine47(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 22,
    viewBox: "0 0 2 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: 0.75,
    x2: 0.75,
    y2: 21.25,
    stroke: "#13044F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine47);
export default __webpack_public_path__ + "static/media/line_47.93eab5da1bef93cda63e9788706300c7.svg";
export { ForwardRef as ReactComponent };